<template>
  <px-base-modal
    v-bind="$attrs"
    :cancel-variant="
      $attrs['cancel-variant'] ? $attrs['cancel-variant'] : 'outline-primary'
    "
    centered
    data-testid="confirm-modal"
    :footer-class="
      equalWidthButtons
        ? 'equal-width-footer'
        : $attrs['footer-class'] || '' + ' m-auto'
    "
    ok-id="$attrs['ok-id']"
    :size="size"
    :title-icon="titleIcon"
    :title-icon-class="titleIconClass"
    :title-icon-color="titleIconColor"
    v-on="$listeners"
  >
    <slot></slot>

    <template #modal-footer="{ ok, cancel }">
      <div
        :class="{
          'w-100': !rightAlignButtons,
          'd-flex': true,
          'equal-width-buttons': equalWidthButtons,
        }"
      >
        <b-button
          :variant="$attrs['cancel-variant'] || 'outline-primary'"
          @click="cancel()"
        >
          {{ $attrs['cancel-title'] || 'Cancel' }}
        </b-button>

        <div v-if="okLoading">
          <px-icon
            :class="{ 'icon spinning': okLoading, 'w-100': true }"
            icon="arrows-rotate"
          />
          <span>{{ okText }}</span>
        </div>
        <b-button v-else :variant="$attrs['ok-variant']" @click="ok()">
          <px-icon v-if="okIcon" :icon="okIcon" />
          <span>{{ okText }}</span>
        </b-button>
      </div>

      <div v-if="tertiaryTitle" class="text-center w-100">
        <b-button variant="link" @click="$emit('tertiary-click')">
          {{ tertiaryTitle }}
        </b-button>
      </div>
    </template>
  </px-base-modal>
</template>

<script>
export default {
  name: 'PxConfirmModal',
  props: {
    tertiaryTitle: {
      type: String,
      required: false,
      default: '',
    },
    okLoading: {
      type: Boolean,
      required: false,
      default: null,
    },
    okLoadingTitle: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: String,
      required: false,
      default: 'sm',
    },
    rightAlignButtons: {
      type: Boolean,
      required: false,
      default: false,
    },
    okIcon: {
      type: String,
      required: false,
      default: '',
    },
    titleIcon: {
      type: String,
      required: false,
      default: '',
    },
    titleIconClass: {
      type: String,
      required: false,
      default: '',
    },
    titleIconColor: {
      type: String,
      required: false,
      default: '',
    },
    equalWidthButtons: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    okText() {
      if (this.okLoading) {
        return this.okLoadingTitle;
      } else {
        return this.$attrs['ok-title'];
      }
    },
  },
};
</script>

<style scoped>
.btn .px-icon {
  margin-right: 6px;
}

.equal-width-buttons {
  justify-content: space-between;
  gap: 12px;
}

.equal-width-buttons .btn {
  flex: 0 0 calc(50% - 6px);
  max-width: calc(50% - 6px);
}
</style>

<style lang="scss">
.equal-width-footer {
  margin: 0 !important;
}
</style>
